const lux = (() => {
    return () => (next: Function) => (action: any) => {
        switch (action.type) {
            case '@@router/LOCATION_CHANGE':
                // @ts-ignore
                if (typeof window !== 'undefined' && window.LUX) {
                    const {
                        isFirstRendering,
                        location: { pathname },
                    } = action.payload;
                    // @ts-ignore
                    window.LUX.label = getPageLabel(pathname);
                    if (!isFirstRendering) {
                        // @ts-ignore
                        window.LUX.init();
                    }
                }

                break;
            default:
                break;
        }
        return next(action);
    };
})();

export default lux;

const getPageLabel = (pathname: string = '') => {
    let label = PATHNAMES[pathname];
    if (label) {
        return label;
    }

    if (pathname.includes('/item/')) {
        return 'item page';
    }

    if (pathname.includes('/item/')) {
        return 'item page';
    }

    if (pathname.includes('/catalog/search')) {
        return 'catalog search page';
    }

    if (pathname.includes('/catalog/')) {
        return 'catalog page';
    }

    if (pathname.includes('/terms/')) {
        return 'catalog terms page';
    }

    if (pathname.includes('/console/')) {
        return 'console page';
    }

    if (pathname.includes('/auctioneer/')) {
        return 'auctioneer page';
    }

    if (pathname.includes('/seller/')) {
        return 'seller page';
    }

    if (pathname.includes('/c/')) {
        return 'category page';
    }

    return pathname.replace('/', '').trim();
};

const PATHNAMES = {
    '/': 'home',
    '/about': 'about',
    '/auction-results': 'auction results',
    '/auctioneer/directory': 'auctioneer directory',
    '/dashboard/profile': 'dashboard',
};
